/* HOD PDP blocks (9/7): Looks carousel in the Brand band — slides, dots, swipe, and the
   product-list popover / bottom sheet that mirrors the homepage Get Inspired block.
   Popovers live outside the transformed track (children of .hod-looks__stage) and are looked up
   by data-hod-looks-pop="{index}"; since 10/18 the chips sit in the control bar under the photo
   (data-hod-looks-chip="{index}", the active one carries .is-on). Page-level listeners are registered once and dispatch to instances. */
(function () {
  'use strict';
  var MQ = window.matchMedia('(max-width: 820px)');
  function instances() { return Array.prototype.slice.call(document.querySelectorAll('[data-hod-looks]')).map(function (r) { return r.__hodLooks; }).filter(function (i) { return i && typeof i === 'object'; }); }

  function init(root) {
    if (root.__hodLooks) return;
    var track = root.querySelector('[data-hod-looks-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-hod-looks-slide]'));
    if (!track || !slides.length) { root.__hodLooks = true; return; }
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-hod-looks-dot]'));
    var prev = root.querySelector('[data-hod-looks-prev]');
    var next = root.querySelector('[data-hod-looks-next]');
    var scrim = root.querySelector('[data-hod-looks-scrim]');
    var stage = root.querySelector('.hod-looks__stage');
    var cur = 0, open = false;

    function popFor(i) { return root.querySelector('[data-hod-looks-pop="' + i + '"]'); }
    /* 10/18: chips live in the control bar (data-hod-looks-chip); older markup kept them inside the slide */
    function chipFor(i) { return root.querySelector('[data-hod-looks-chip="' + i + '"]') || (slides[i] && slides[i].querySelector('[data-hod-looks-open]')) || null; }
    function paint() {
      track.style.transform = 'translateX(' + (-cur * 100) + '%)';
      slides.forEach(function (s, i) {
        var on = i === cur;
        s.classList.toggle('is-on', on);
        if (on) { s.removeAttribute('aria-hidden'); s.removeAttribute('inert'); }
        else { s.setAttribute('aria-hidden', 'true'); s.setAttribute('inert', ''); }
        var pop = popFor(i);
        if (pop) {
          pop.hidden = !(on && open);
          if (pop.hidden) pop.removeAttribute('aria-modal');
          else if (MQ.matches) pop.setAttribute('aria-modal', 'true');
        }
        var chip = chipFor(i);
        if (chip) {
          chip.setAttribute('aria-expanded', on && open ? 'true' : 'false');
          if (chip.hasAttribute('data-hod-looks-chip')) { chip.classList.toggle('is-on', on); chip.hidden = !on; }
        }
      });
      dots.forEach(function (d, i) {
        var don = i === cur;
        d.classList.toggle('is-on', don);
        d.setAttribute('aria-selected', don ? 'true' : 'false');
        d.setAttribute('tabindex', don ? '0' : '-1');   /* roving tabindex (review 10/18): one Tab stop for the dots */
      });
      /* 10/19: arrows stay live at both ends (the carousel loops) */
      if (prev) { prev.removeAttribute('data-disabled'); prev.setAttribute('aria-disabled', 'false'); }
      if (next) { next.removeAttribute('data-disabled'); next.setAttribute('aria-disabled', 'false'); }
      if (scrim) scrim.hidden = !(open && MQ.matches);
    }
    function focusQuiet(el) { if (!el) return; try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); } }
    /* 10/19: our own 260ms ease for the page nudge — native smooth scrollBy was silently ignored on the live PDP (another script's scroll was in flight) */
    function nudgeBy(dy) {
      if (!dy) return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) { window.scrollBy(0, dy); return; }
      var from = window.scrollY, t0 = null, done = false;
      function step(ts) { if (done) return; if (t0 === null) t0 = ts; var k = Math.min(1, (ts - t0) / 260); var e = 1 - Math.pow(1 - k, 3); window.scrollTo(0, from + dy * e); if (k < 1) requestAnimationFrame(step); else done = true; }
      requestAnimationFrame(step);
      setTimeout(function () { if (t0 === null && !done) { done = true; window.scrollTo(0, from + dy); } }, 120);   /* no frame painted (hidden tab, throttled page): land instantly instead of never */
    }
    function go(i) {
      /* 10/19 (Stas): the carousel loops — past the last look comes the first, before the first the last.
         The long jump across the track is a hard cut (the 0.45 s slide would swoosh across every look). */
      var len = slides.length, n = ((i % len) + len) % len;
      if (n === cur) { paint(); return; }
      var wrap = Math.abs(n - cur) > 1 && (n === 0 || cur === 0) && len > 2;
      if (wrap) { track.style.transition = 'none'; }
      var a = document.activeElement, c0 = chipFor(cur), p0 = popFor(cur);
      var hadFocus = (slides[cur] && slides[cur].contains(a)) || (c0 && c0.contains(a)) || (p0 && p0.contains(a));
      var onDot = dots.indexOf(a) !== -1;
      cur = n; open = false;
      paint();
      if (wrap) { void track.offsetWidth; track.style.transition = ''; }
      if (hadFocus) focusQuiet(chipFor(cur) || stage);   /* focus sat on the chip / pop / slide that just hid: move it to the new look's chip */
      else if (onDot) focusQuiet(dots[cur]);             /* roving tabindex: focus follows the selected tab */
    }
    function closePop() {
      var pop = popFor(cur);
      var inside = pop && pop.contains(document.activeElement);
      open = false;
      paint();
      if (inside) focusQuiet(chipFor(cur));
    }
    function openPop(i) {
      cur = i; open = true; paint();
      var p = popFor(i), x = p && p.querySelector('[data-hod-looks-close]');
      focusQuiet(x);   /* 10/19 (Stas): no page jump — focusing the × used to centre it in the viewport, which yanked the page up by ~800px */
      /* if the panel is partly off-screen, nudge the page by the smallest amount that shows it (phones: the sheet is fixed, so nothing moves) */
      if (p && getComputedStyle(p).position !== 'fixed') {
        var pr = p.getBoundingClientRect(), top = 90, bottom = window.innerHeight - 16, dy = 0;   /* 90px keeps the panel clear of the sticky header */
        if (pr.top < top) dy = pr.top - top; else if (pr.bottom > bottom) dy = Math.min(pr.bottom - bottom, pr.top - top);
        if (dy) nudgeBy(dy);
      }
    }
    slides.forEach(function (s, i) {
      var chip = chipFor(i);
      if (chip) chip.addEventListener('click', function (e) {
        e.stopPropagation();
        if (open && cur === i) { closePop(); return; }   /* second click closes */
        openPop(i);
      });
      /* the pop precedes its chip in the DOM (10/18): Tab from the expanded chip enters the open pop instead of skipping to the dots */
      if (chip) chip.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab' || e.shiftKey || !open || cur !== i) return;
        var p = popFor(i), x = p && !p.hidden && p.querySelector('[data-hod-looks-close]');
        if (x) { e.preventDefault(); focusQuiet(x); }
      });
      var pop = popFor(i);
      if (pop) {
        var x = pop.querySelector('[data-hod-looks-close]');
        if (x) x.addEventListener('click', function (e) { e.stopPropagation(); closePop(); });
        /* Tab handling: the bottom sheet (aria-modal, phones) keeps Tab inside the dialog; the desktop popover (non-modal) hands
           Shift+Tab from its first control back to the chip that opened it and closes on Tab past the last control.
           Needed since 10/18: the pop (child of .hod-looks__stage) now precedes its chip (.hod-looks__bar) in the DOM. */
        pop.addEventListener('keydown', function (e) {
          if (e.key !== 'Tab') return;
          var f = pop.querySelectorAll('a[href], button:not([disabled])');
          if (!f.length) return;
          var first = f[0], last = f[f.length - 1], modal = pop.getAttribute('aria-modal') === 'true';
          if (e.shiftKey && document.activeElement === first) { e.preventDefault(); if (modal) last.focus(); else focusQuiet(chipFor(i)); }
          else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); if (modal) first.focus(); else closePop(); }   /* closePop sees focus inside and returns it to chipFor(cur) */
        });
      }
    });
    if (prev) prev.addEventListener('click', function () { go(cur - 1); });
    if (next) next.addEventListener('click', function () { go(cur + 1); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });
    if (scrim) scrim.addEventListener('click', closePop);
    /* swipe between looks — axis-locked on the first move so a page scroll never flips the look */
    var sx = null, sy = 0, dx = 0, axis = null, swiped = false;
    if (stage) {
      /* 9/14 (Stas): on phones a tap anywhere on the photo opens the product tray,
         not just the chip. A swipe (axis locked to x) never counts as a tap, and the
         click must not bubble to the document's outside-click closer. */
      stage.addEventListener('click', function (e) {
        if (!window.matchMedia || !window.matchMedia('(max-width: 820px)').matches) return;
        if (!e.target.closest('.hod-looks__img')) return;
        if (swiped) { swiped = false; return; }
        if (chipFor(cur) === null) return;          /* look with no products: nothing to open */
        e.stopPropagation();
        if (open) { closePop(); return; }
        openPop(cur);
      });
      stage.addEventListener('touchstart', function (e) {
        if (e.target.closest('[data-hod-looks-pop]')) { sx = null; return; }
        sx = e.touches[0].clientX; sy = e.touches[0].clientY; dx = 0; axis = null; swiped = false;
      }, { passive: true });
      stage.addEventListener('touchmove', function (e) {
        if (sx === null) return;
        var x = e.touches[0].clientX - sx, y = e.touches[0].clientY - sy;
        if (!axis && (Math.abs(x) > 8 || Math.abs(y) > 8)) axis = Math.abs(x) > Math.abs(y) ? 'x' : 'y';
        dx = x;
      }, { passive: true });
      var endSwipe = function () {
        if (sx !== null && axis === 'x' && Math.abs(dx) > 40) { swiped = true; go(cur + (dx < 0 ? 1 : -1)); }
        else if (sx !== null && axis !== null) { swiped = true; }   /* any real drag: not a tap */
        sx = null; dx = 0; axis = null;
      };
      stage.addEventListener('touchend', endSwipe);
      stage.addEventListener('touchcancel', function () { sx = null; dx = 0; axis = null; });
    }
    /* 10/1 (Stas): horizontal trackpad / mouse-wheel swipes and mouse drags move between looks on desktop
       (phones swipe natively above). Gesture lock as in hod-home.js initInsp: a 150 ms pause ends the gesture,
       the inertia tail is swallowed, a reversal re-arms, so one swipe = one look. */
    if (stage) {
      var wAcc = 0, wLock = false, wLast = 0, wDir = 0, wPeak = 0, wPrev = 0, wDecay = false, wDown = 0;
      stage.addEventListener('wheel', function (e) {
        if (MQ.matches || open) return;
        if (e.target.closest('[data-hod-looks-pop]')) return;
        if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;          /* vertical scrolling passes through */
        e.preventDefault();
        var now = Date.now(), mag = Math.abs(e.deltaX);
        /* 10/1 (Stas, iPad): trackpads coast for 1-2 s with no 150 ms gap, so a second swipe in the same direction was
           swallowed as inertia. Deltas that have been decaying and suddenly jump = a new finger push = a new gesture. */
        var fresh = wLock && wDecay && mag > 12 && mag > wPrev * 1.8;
        if (now - wLast > 150 || fresh) { wAcc = 0; wLock = false; }
        wLast = now;
        if (wLock) {
          if (mag > wPeak) wPeak = mag;
          wDown = mag < wPrev ? wDown + 1 : 0;                                  /* three falling samples = a real inertia tail, not one slow frame mid-swipe (review 10/1) */
          if (wDown >= 3 && mag < wPeak * 0.5) wDecay = true;
          wPrev = mag;
          if (e.deltaX * wDir < 0) { wLock = false; wAcc = 0; } else return;   /* swallow the inertia tail; a reversal starts a new gesture */
        }
        wPrev = mag;
        wAcc += e.deltaX;
        if (Math.abs(wAcc) > 60) { wDir = wAcc > 0 ? 1 : -1; go(cur + wDir); wAcc = 0; wLock = true; wPeak = mag; wDecay = false; wDown = 0; }
      }, { passive: false });
      var dX = null, dMoved = false;
      stage.addEventListener('pointerdown', function (e) {
        if (MQ.matches || open || e.pointerType !== 'mouse' || e.button !== 0) return;
        if (e.target.closest('button, a, [data-hod-looks-pop]')) return;
        dX = e.clientX; dMoved = false; e.preventDefault();             /* no ghost-image drag */
      });
      stage.addEventListener('pointermove', function (e) { if (dX === null) return; if (!dMoved && Math.abs(e.clientX - dX) > 40) { dMoved = true; go(cur + (e.clientX < dX ? 1 : -1)); } });
      var dEnd = function () { dX = null; dMoved = false; };
      stage.addEventListener('pointerup', dEnd); stage.addEventListener('pointercancel', dEnd); stage.addEventListener('pointerleave', dEnd);
    }
    root.addEventListener('keydown', function (e) {
      if (e.target.closest('[data-hod-looks-pop]')) return;
      if (e.key === 'ArrowRight') go(cur + 1);
      else if (e.key === 'ArrowLeft') go(cur - 1);
    });
    root.__hodLooks = { root: root, isOpen: function () { return open; }, close: closePop, reset: function () { open = false; paint(); } };
    paint();
  }

  /* page-level listeners: once per page, dispatching to live instances (no per-instance accumulation on shopify:section:load) */
  if (!document.__hodLooksGlobal) {
    document.__hodLooksGlobal = true;
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') instances().forEach(function (i) { if (i.isOpen()) i.close(); }); });
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-hod-looks-pop]') || e.target.closest('[data-hod-looks-open]')) return;
      instances().forEach(function (i) { if (i.isOpen()) i.close(); });
    });
    if (MQ.addEventListener) MQ.addEventListener('change', function () { instances().forEach(function (i) { i.reset(); }); });
  }
  function boot() { document.querySelectorAll('[data-hod-looks]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
